export const METAMASK_PROVIDER = "METAMASK_PROVIDER";
export const KEPLR_PROVIDER = "KEPLR_PROVIDER";
export const NO_PROVIDER = "NO_PROVIDER";
export const NO_WALLET = "NO_WALLET";
export const NO_PUBKEY = "NO_PUBKEY";
